import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-bold-edit',
    imports: [],
    templateUrl: './icon-bold-edit.html',
    styleUrl: './icon-bold-edit.css'
})
export class IconBoldEdit {
    @Input() color: string = 'currentColor';
    @Input() size: string = '24px';
}
